<template>
  <div class="message-bill">
    <div class="section-right-content-box">
      <div class="box-shadow top-box">
        <div class="global-title">短信记录</div>
      </div>

      <div class="navTab">
        <span
          class="tab"
          :class="{ active: topSelect == 2 }"
          @click="changeTo(2)"
          >短信记录</span
        >
        <!-- <span
          class="tab"
          :class="{ active: topSelect == 1 }"
          @click="changeTo(1)"
          >短信回复</span
          > -->
        <span
          class="tab"
          :class="{ active: topSelect == 0 }"
          @click="changeTo(0)"
          >富信记录</span
        >
        <span
          class="tab"
          :class="{ active: topSelect == 3 }"
          @click="changeTo(3)"
          >卡片记录</span
        >
      </div>
      <div v-if="topSelect == 2 || topSelect == 0 || topSelect == 3">
        <!-- 筛选部分 -->
        <div class="input-form-box">
          <formOne
            v-show="smsType == 0 && topSelect != 3"
            :smsType="0"
            key="1"
            @onSerach="searchFormOne"
            ref="formOne0"
          ></formOne>
          <formOne
            v-show="smsType == 1 && topSelect != 3"
            :smsType="1"
            key="2"
            @onSerach="searchFormOne"
            ref="formOne1"
          ></formOne>
          <formOne
            v-show="topSelect == 3"
            :smsType="1"
            key="1"
            @onSerach="searchFormOne"
            ref="formOne2"
          ></formOne>
          <el-button
            @click="getphone()"
            type="primary"
            style="margin-bottom: 13px"
            >导出</el-button
          >
        </div>
        <!-- 表格部分 -->
        <div class="table-box" style="padding: 5px 26px 26px 26px">
          <el-table
            ref="multipleTable"
            :data="countTable"
            v-loading="loading"
            tooltip-effect="light"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
            :cell-style="{ 'text-align': 'left' }"
            style="width: 100%; opacity: 1"
          >
            <template slot="empty">
              <div>
                <img src="@/assets/images/default/暂无任何数据.png" />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>
            <el-table-column width="33"></el-table-column>
            <el-table-column
              prop="activityTitle"
              label="活动主题"
              width="240px"
            ></el-table-column>
            <el-table-column prop="officialFlag" label="活动类型" width="112px">
              <template slot-scope="scope">
                <!-- <template v-if="smsType == 0">
                  <span
                    v-if="recordData.dataFrom != 11 && recordData.dataFrom != 3"
                  >
                    {{
                      scope.row.officialFlag == true ? "官方发送" : "平台发送"
                    }}
                  </span>
                  <span v-else> 官方发送 </span>
                </template> -->
                <!-- <template v-else>
                  {{ activityTypeStr }}
                </template> -->
                {{ scope.row.activityType }}
              </template>
            </el-table-column>
            <el-table-column
              prop="content"
              label="短信内容"
              width="362px"
              v-if="smsType == 0"
            >
              <template slot="header">
                <span
                  >短信内容
                  <span
                    class="table-message"
                    style="cursor: pointer"
                    v-if="!allShow"
                    @click="allShow = true"
                    >(展开全部)</span
                  >
                  <span
                    class="table-message"
                    style="cursor: pointer"
                    v-if="allShow"
                    :style="{ color: changeColor }"
                    @click="allShow = false"
                    >(单行显示)</span
                  >
                </span>
              </template>
              <template slot-scope="scope">
                <div class="hoveTitle" v-if="!allShow">
                  {{ scope.row.content }}
                </div>
                <div v-else>{{ scope.row.content }}</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="content"
              label="短信内容"
              width="362px"
              v-else-if="smsType == 1"
            >
              <template slot-scope="scope">
                <span class="rich_title" @click="showMediaInfo(scope.row)">{{
                  scope.row.mediaTitle
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="content"
              label="短信内容"
              width="362px"
              v-else-if="smsType == 2"
            >
              <template slot-scope="scope">
                <span class="rich_title" @click="showCardInfo(scope.row)">{{
                  scope.row.mediaTitle
                }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="sendStatus" label="发送状态" width="148px">
              <template slot-scope="scope">
                <span>
                  <template
                    v-if="recordData.dataFrom != 11 && recordData.dataFrom != 3"
                  >
                    <span
                      class="dot"
                      :class="[
                        scope.row.sendStatus == '3' ? 'dot-0' : '',
                        scope.row.sendStatus == '2' ? 'dot-1' : '',
                        scope.row.sendStatus == '4' ? 'dot-2' : '',
                        scope.row.sendStatus == '6' ? 'dot-1' : '',
                        scope.row.sendStatus == '7' ? 'dot-3' : '',
                        scope.row.sendStatus == '1' ? 'dot-4' : '',
                        scope.row.sendStatus == '8' ? 'dot-2' : '',
                      ]"
                    ></span>
                    {{ scope.row.sendStatus | statusStr }}
                    <el-tooltip v-if="scope.row.sendStatus == '7' || scope.row.sendStatus == '4' || scope.row.sendStatus == '5' || scope.row.sendStatus == '8'" class="item" effect="light" :content="scope.row.failMessage" placement="top">
                      <span class="question_icon" style="color: #fe4d45 !important; border-color: #fe4d45;width:14px;">?</span>
                    </el-tooltip>
                  </template>
                  <template v-else>
                    <span
                      class="dot"
                      :class="[
                        scope.row.sendStatus == '101' ? 'dot-0' : '',
                        scope.row.sendStatus == '3' ? 'dot-1' : '',
                        scope.row.sendStatus == '5' ? 'dot-2' : '',
                        scope.row.sendStatus == '102' ? 'dot-3' : '',
                        scope.row.sendStatus == '4' ? 'dot-3' : '',
                        scope.row.sendStatus == '1' ? 'dot-4' : '',
                      ]"
                    ></span>
                    {{ scope.row.sendStatus | statusStrPre }}
                    <el-tooltip v-if="scope.row.sendStatus == '102' || scope.row.sendStatus == '4' || scope.row.sendStatus == '8' " class="item" effect="light" :content="scope.row.failMessage" placement="top">
                      <span class="question_icon" style="color: #fe4d45 !important; border-color: #;width:14px;">?</span>
                    </el-tooltip>
                  </template>
                </span>
              </template>
            </el-table-column>
            <el-table-column label="提交时间" width="209px">
              <template slot-scope="scope">
                <div v-if="recordData.dataFrom == 3">
                  {{ scope.row.subTime }}
                </div>
                <div v-else>{{ scope.row.submitTime }}</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="sendTime"
              label="发送时间"
              width="209px"
            ></el-table-column>
            <el-table-column
              prop="sendSubmitNum"
              label="发送人数"
              width="107px"
            ></el-table-column>
            <el-table-column
              prop="feeCount"
              label="扣费条数"
              width="114px"
            ></el-table-column>
            <el-table-column prop="operate" label="操作" width="180px">
              <!-- <el-button type="text" @click="dialogFormVisible = true"> -->
              <template slot-scope="scope">
                <div
                  v-if="recordData.dataFrom != 11 && recordData.dataFrom != 3"
                  class="operation-wrap"
                >
                  <el-button
                    v-if="
                      scope.row.sendStatus == 1 || scope.row.sendStatus == 2
                    "
                    type="text"
                    v-zoom="{ from: pageName, name: '取消发送' }"
                    @click="handleCancelSend(scope.row)"
                  >
                    取消发送
                  </el-button>
                  <el-button v-else type="text" style="color: #dddddd">
                    取消发送
                  </el-button>
                  <el-button
                    type="text"
                    v-zoom="{ from: pageName, name: '短信记录' }"
                    @click="sortRecord(scope.row)"
                  >
                    短信记录
                  </el-button>
                </div>
                <!-- 精准营销操作 -->
                <div v-else class="operation-wrap">
                  <el-button
                    v-if="
                      scope.row.sendStatus == 1 || scope.row.sendStatus == 3
                    "
                    type="text"
                    v-zoom="{ from: pageName, name: '取消发送' }"
                    @click="handleCancelSend(scope.row)"
                  >
                    取消发送
                  </el-button>
                  <el-button v-else type="text" style="color: #dddddd">
                    取消发送
                  </el-button>
                  <el-button type="text" style="color: #dddddd">
                    短信记录
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            style="text-align: right; margin-top: 20px"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[10, 20, 30, 50, 100, 500]"
            :page-size="recordData.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            :current-page="recordData.current"
          ></el-pagination>
        </div>
      </div>

      <div v-if="topSelect == 1">
        <input-form
          style="margin: 25px 0 0 -10px"
          :inputData="inputData1"
          @toParentVal="searchContent"
        ></input-form>
        <div class="headBtns">
          <button class="b1" @click="callBackDef()">
            <!-- <img src="../../assets/images/set_icon.png" class="icon" /> -->
            群发回复
          </button>
          <button class="b2" @click="readDefine()">一键标记为已读</button>
          <button class="b3" @click="blacklistDef()">加入黑名单</button>
          <button class="b3" @click="toggleSelection()">批量删除</button>
        </div>
        <el-button class="daoChu" @click="exportRec()">导出数据</el-button>

        <el-table
          :data="tableDataReply"
          class="tabCallback"
          v-loading="loading"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
          @selection-change="handleSelectionChange"
        >
          <template slot="empty">
            <div>
              <img src="@/assets/images/default/暂无任何数据.png" />
              <span style="margin-left: -140px">暂无任何数据</span>
            </div>
          </template>
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="mobile" label="手机号码" width="180">
          </el-table-column>
          <el-table-column label="发送内容" width="250">
            <template slot="header">
              <span
                >短信内容
                <span
                  class="table-message"
                  style="cursor: pointer"
                  v-if="!allShow"
                  @click="allShow = true"
                  >(展开全部)</span
                >
                <span
                  class="table-message"
                  style="cursor: pointer"
                  v-if="allShow"
                  :style="{ color: changeColor }"
                  @click="allShow = false"
                  >(单行显示)</span
                >
              </span>
            </template>
            <template slot-scope="scope">
              <div class="hoveTitle" v-if="!allShow">
                {{ scope.row.sendContent }}
              </div>
              <div v-else>{{ scope.row.sendContent }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="comefrom" label="短信类型" width="150">
          </el-table-column>
          <el-table-column prop="sendTime" label="发送时间" width="200">
          </el-table-column>
          <el-table-column prop="content" label="回复内容" width="200">
          </el-table-column>
          <el-table-column prop="crtime" label="回复时间" width="200">
          </el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.state == 0">已读</span>
              <span v-if="scope.row.state == 1">未读</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="180">
            <template slot-scope="scope">
              <el-button
                type="text"
                style="width: 55px; color: #7f85e9"
                @click="callBackDef(scope.row)"
                >回复</el-button
              >
              <el-button
                type="text"
                style="width: 55px"
                @click="toggleSelection(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          style="text-align: right; padding: 40px"
          @size-change="handleSizeChangeTwo"
          @current-change="handleCurrentChangeTwo"
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNumTwo"
          :current-page="1"
        ></el-pagination>
      </div>
    </div>

    <!-- 短信记录弹窗 -->
    <el-dialog title="短信记录:" :visible.sync="dialogFormVisible" width="80%">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="买家昵称:" style="margin-right: 80px">
          <el-input v-model="formInline.user" placeholder="输入昵称"></el-input>
        </el-form-item>
        <el-form-item label="手机号码:" style="margin-right: 80px">
          <el-input
            v-model="formInline.number"
            placeholder="输入手机号码"
          ></el-input>
        </el-form-item>
        <el-form-item label="发送状态:" style="margin-right: 80px">
          <el-select v-model="formInline.sendStatus" placeholder="全部">
            <el-option label="全部" value=""></el-option>
            <el-option label="已发送" value="1"></el-option>
            <el-option label="未发送" value="0"></el-option>
            <el-option label="黑名单过滤" value="2"></el-option>
            <el-option label="过滤重复发送" value="3"></el-option>
            <el-option label="十分钟内容重复" value="4"></el-option>
            <el-option label="无效号码" value="5"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button class="b1" @click="recordPopupQuery">查询</el-button>
          <el-button class="b2" @click="recordPopupReset">重置</el-button>
        </el-form-item>
      </el-form>
      <el-table
        :data="gridData"
        tooltip-effect="light"
        :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
        :cell-style="{ 'text-align': 'left' }"
        style="width: 100%;opacity:1;ma
        rgin-top:20px;"
      >
        <template slot="empty">
          <div>
            <img src="@/assets/images/default/暂无任何数据.png" />
            <span style="margin-left: -140px">暂无任何数据</span>
          </div>
        </template>
        <el-table-column
          property="desensitizePin"
          label="买家昵称"
          width="160px"
        ></el-table-column>
        <el-table-column property="mobile" label="手机号码" width="200px">
          <template slot-scope="scope">{{ scope.row.mobile || "--" }}</template>
        </el-table-column>
        <el-table-column prop="content" label="短信内容" width="362px">
          <template slot="header">
            <span
              >短信内容
              <span
                class="table-message"
                style="cursor: pointer"
                v-if="!allShowOne"
                @click="allShowOne = true"
                >(展开全部)</span
              >
              <span
                class="table-message"
                style="cursor: pointer"
                v-if="allShowOne"
                :style="{ color: changeColor }"
                @click="allShowOne = false"
                >(单行显示)</span
              >
            </span>
          </template>
          <template slot-scope="scope">
            <div class="hoveTitle" v-if="!allShowOne">
              {{ scope.row.content }}
            </div>
            <div v-else>{{ scope.row.content }}</div>
          </template>
        </el-table-column>
        <el-table-column
          property="smsNumber"
          label="计费条数"
          width="170px"
        ></el-table-column>
        <el-table-column property="status" label="发送状态" width="170px">
          <template slot-scope="scope">
            <span>
              <span
                class="dot"
                :class="[
                  scope.row.status == '1' ? 'dot-0' : '',
                  scope.row.status == '0' ? 'dot-1' : '',
                  scope.row.status == '5' ? 'dot-2' : '',
                  scope.row.status == '3' ? 'dot-3' : '',
                  scope.row.status == '4' ? 'dot-4' : '',
                ]"
              ></span>
              {{ scope.row.status | statusStrOne }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          property="subTime"
          label="提交时间"
          width="250px"
        ></el-table-column>
        <el-table-column property="sendTime" label="发送时间"></el-table-column>
      </el-table>
      <el-pagination
        background
        style="text-align: right; margin-top: 20px"
        :page-sizes="[10, 20, 30, 50, 100, 500]"
        :page-size="sortNum.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="recordTotal"
        :current-page="sortNum.current"
        @size-change="handleSizeChangeOne"
        @current-change="handleCurrentChangeOne"
      ></el-pagination>
    </el-dialog>

    <!-- 删除活动弹框 -->
    <el-dialog title="提示" :visible.sync="dialogFormVis" width="400px"
      ><img
        src="@/assets/images/tips_icon.png"
        class="tips"
        style="
          margin: 6px 0px 0px 110px;
          position: absolute;
          width: 22px;
          height: 22px;
        "
      />
      <span
        style="position: absolute; margin: 10px 0px 0px 140px; font-size: 14px"
        >是否删除短信？</span
      >
      <span slot="footer" class="buttonBox">
        <el-button class="b1" @click="dialogFormVis = false">取 消</el-button>
        <el-button class="b2" @click="deleteDefine">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="添加黑名单" :visible.sync="dialogFormBlack" width="500px">
      <span style="margin-left: 15px"
        >已选号码:
        <span style="color: #fe4d45">{{ currentRow.length }}</span> 个</span
      ><br />
      <el-form style="margin: 20px 0 0 0" label-width="60px">
        <el-form-item label="备注:">
          <el-input
            type="textarea"
            placeholder="请输入内容"
            v-model="remark"
            maxlength="50"
            show-word-limit
            style="width: 350px"
          >
          </el-input>
        </el-form-item>
        <el-form-item style="margin: 40px 0 -10px 60px">
          <el-button type="primary" @click="blacklistDefine">确定</el-button>
          <el-button @click="dialogFormBlack = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 导出 -->
    <el-dialog title="导出数据" :visible.sync="dialogFormExport" width="500px">
      <el-form style="margin: 20px 0 0 0" label-width="60px">
        <el-form-item>
          <el-checkbox
            :indeterminate="isIndeterminate"
            v-model="checkAll"
            @change="handleCheckAllChange"
            >全选</el-checkbox
          >
          <div style="margin: 15px 0"></div>
          <el-checkbox-group
            v-model="checkedCities"
            @change="handleCheckedCitiesChange"
          >
            <el-checkbox v-for="city in cities" :label="city" :key="city">{{
              city
            }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item style="margin: 40px 0 -10px 70px">
          <el-button type="primary" @click="exportData()">确定</el-button>
          <el-button @click="dialogFormExport = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 发送短信 -->
    <send-sms
      :drawer="drawer"
      @close="drawerClose"
      taskName="短信回复"
      :checkData="multipleSelection"
      :sendType="sendType"
      :count="checkCount"
      :dataFrom="4"
      :searchForm="searchParams"
      @onViewRecord="handleViewRecord"
      @onConSending="drawerClose"
    ></send-sms>

    <!-- Tag://  -->
    <el-dialog
      title="身份验证"
      width="600px"
      :show-close="false"
      custom-class="system-dialog"
      :visible.sync="visible"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <div class="form-box">
        <div class="form-item">
          <div class="item-label">手机号：</div>
          <div class="item-value">
            <el-input
              disabled
              placeholder="请输入..."
              v-model="phoneStr"
              style="width: 280px"
            ></el-input>
          </div>
        </div>
        <div class="form-item">
          <div class="item-label">验证码：</div>
          <div class="item-value">
            <el-input
              placeholder="请输入"
              v-model="code"
              style="width: 170px; margin-right: 12px"
            ></el-input>
            <el-button
              type="primary"
              :disabled="codeDisabled"
              @click="getCode"
              >{{ codeMsg }}</el-button
            >
          </div>
        </div>
        <div class="form-item" style="margin-bottom: 8px">
          <div class="form-item" style="margin-bottom: 8px">
            <div class="item-label"></div>
            <div class="item-value">
              <div class="tip-box" style="background: #fff"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="save-btn">
        <button class="keepBtn" @click="downloadFileMessage()">确定</button>
        <button class="backBtn" @click="visible = false">取消</button>
      </div>
    </el-dialog>
    <!-- 富信模板 -->
    <sms-info
      v-if="smsInfoShow"
      @close="smsInfoShow = false"
      :isShow="smsInfoShow"
      :id="smsInfoId"
      :title="smsInfoTitle"
      :text="smsInfoText"
    />
    <sms-info-card 
      v-if="smsInfoCardShow"
      :isShow="smsInfoCardShow"
      :id="smsInfoCardId"
      @close="smsInfoCardShow = false" 
    ></sms-info-card>
    <!-- 生成报表 -->
    <generate
      :control="control"
      v-if="control"
      @transData="(val) => (control = val)"
      @transData1 = 'getphone1'
    ></generate>
  </div>
</template>

<script>
/**
 * 2023.07.28
 * 1.注意，此处查询，活动类型不同时 ，传递的参数会不一致，但接口是同一个。（目前不一致的有 精准营销、智能营销）
 * 初始化时，目前 "手动催付" 跳转过来的，需要更改活动类型 ，后续需更改活动类型的，也可继续使用activityType字段
 * 更改表单需注意数据流向，部分情况使用当前组件的recordData，其余情况均使用子组件input_form的formData
 */
import {
  recordList,
  sendDetail,
  sendDetailRecord,
  sendRecordMes,
  deleteRecordMes,
  readRecordMes,
  exportRecordMes,
} from "@/api/backstage/messageBill";
import { sendCancel } from "@/api/smsSend";
import { cancelSendSms } from "@/api/marketing/precisionMarketing";
import { cancelSendSms as cancelSendSms2 } from "@/api/intelligentMarket/index";
import { getSellerInfo } from "@/api/sellerController"; //获取当前客户信息
import { getSmsRecordPage } from "@/api/intelligentMarket";
import { getRecordListOfficial } from "@/api/marketing/precisionMarketing";
import { insertBlack } from "@/api/smsBlackList";
import sendSms from "@/views/serviceCenter/components/sendSms";
import generate from "../../components/generate_report.vue";
// import { sendBatchPage } from "@/api/smsSend";
var month = new Date();
var monthNum = month.getMonth() - 1;
var oneMonthAgo = month.setMonth(monthNum);
import inputForm from "../../components/inputForm";
import formOne from "./inputFrom/input_form";
import { mapState, mapMutations } from "vuex";
import {
  querySellerSetting,
  getSellerCheckCode,
  setMessageGf,
  setMessageft,
  setMessageJz,
} from "@/api/downloadFile.js";
import smsInfo from "@/components/sms-info";
import smsInfoCard from "@/components/sms-info-card";
export default {
  name: "message-bill",
  filters: {
    statusStr(status) {
      return {
        1: "待审核",
        2: "待发送",
        3: "已发送",
        4: "已取消",
        5: "发送失败",
        6: "提交中 ",
        7: "提交失败",
        8: "审核未通过",
        9: "发送中",
        null: "null",
      }[status];
    },
    // 精准营销
    statusStrPre(status) {
      return {
        1: "待审核",
        3: "待发送",
        4: "审核未通过",
        5: "已取消",
        100: "发送中",
        101: "已发送",
        102: "发送失败",

        null: "null",
      }[status];
    },
    statusStrOne(status) {
      return {
        1: "已发送",
        0: "未发送",
        2: "黑名单过滤",
        3: "过滤重复发送",
        4: "10分钟内容重复",
        5: "无效号码",
        6: "给过中差评过滤",
        7: "退过款过滤",
        null: "null",
      }[status];
    },
  },
  data() {
    return {
      smsInfoCardShow: false, // 
      smsInfoCardId: "", // 
      control: false,
      shopInfo: {},
      pageName: "后台管理-短信记录",
      activityTypeStr: "",
      smsInfoShow: false, // 富信
      smsInfoId: "", // 富信id
      smsInfoTitle: "", // 富信标题
      smsInfoText: "", // 富信内容
      smsType: 0, // 短信类型，0：普通，1：富信
      dialogFormExport: false,
      checkAll: false,
      checkedCities: [],
      cities: ["手机号码", "发送内容", "发送时间", "回复内容", "回复时间"],
      isIndeterminate: true,
      drawer: false, // 发送短信 模态框
      sendType: 0,
      checkCount: 0,
      searchParams: {}, // 查数据的参数
      loading: false,
      tableDataReply: [],
      //短信记录弹窗
      dialogFormVisible: false,
      dialogFormBlack: false,
      dialogFormVis: false,
      allShow: false, // 信息是否全部显示
      allShowOne: false,
      formInline: {
        user: "",
        number: "",
        sendStatus: "",
      },
      gridData: [],
      /*
       * 统计时间
       * */
      /*
       * 统计表格
       * */
      countTable: [],
      sendDetailTotal: "",
      currentPage: 1,
      showDetail: false,
      //短信记录弹窗
      // sendBatchPage: false,

      //时间选择框是否取消联动
      unlinkPanels: true,
      /*
       * 发送明细表格
       * */
      searchTime: [
        this.moment(month).format("YYYY-MM-DD HH:mm:ss"),
        this.moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      ],
      // countTime: [month, new Date()],
      countTime: [
        this.getDateStr(-30) + " 00:00:00",
        this.getDateStr(0) + " 23:59:59",
      ],
      sendDetail: [],
      options: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "会员发送",
          label: "会员发送",
        },
        {
          value: "订单发送",
          label: "订单发送",
        },
        {
          value: "智能营销",
          label: "智能营销",
        },
        {
          value: "指定号码发送",
          label: "指定号码发送",
        },
        {
          value: "导入号码发送",
          label: "导入号码发送",
        },
        {
          value: "测试发送",
          label: "测试发送",
        },
        {
          value: "会员互动",
          label: "会员互动",
        },
        {
          value: "买家回复提醒",
          label: "买家回复提醒",
        },
        {
          value: "下单关怀",
          label: "下单关怀",
        },
        {
          value: "下单关怀(货到)",
          label: "下单关怀(货到)",
        },
        {
          value: "常规催付",
          label: "常规催付",
        },
        {
          value: "二次催付",
          label: "二次催付",
        },
        {
          value: "预售催付",
          label: "预售催付",
        },
        {
          value: "聚划算催付",
          label: "聚划算催付",
        },
        {
          value: "付款关怀",
          label: "付款关怀",
        },
        {
          value: "智能凑单",
          label: "智能凑单",
        },
        {
          value: "延迟发货",
          label: "延迟发货",
        },
        {
          value: "发货提醒",
          label: "发货提醒",
        },
        {
          value: "疑难件提醒",
          label: "疑难件提醒",
        },
        {
          value: "同城提醒",
          label: "同城提醒",
        },
        {
          value: "派件提醒",
          label: "派件提醒",
        },
        {
          value: "签收提醒",
          label: "签收提醒",
        },
        {
          value: "回款提醒",
          label: "回款提醒",
        },
        {
          value: "自动催评",
          label: "自动催评",
        },
        {
          value: "好评感谢",
          label: "好评感谢",
        },
        {
          value: "中差评安抚",
          label: "中差评安抚",
        },
        {
          value: "申请退款",
          label: "申请退款",
        },
        {
          value: "同意退款",
          label: "同意退款",
        },
        // {
        //   value: "派件提醒",
        //   label: "派件提醒"
        // },
        {
          value: "拒绝退款",
          label: "拒绝退款",
        },
        {
          value: "退款成功",
          label: "退款成功",
        },
        {
          value: "首购有礼",
          label: "首购有礼",
        },
        {
          value: "复购有礼",
          label: "复购有礼",
        },
        {
          value: "休眠提醒",
          label: "休眠提醒",
        },
        {
          value: "满月礼",
          label: "满月礼",
        },
        {
          value: "百日礼",
          label: "百日礼",
        },
        {
          value: "周年礼",
          label: "周年礼",
        },
        {
          value: "生日关怀",
          label: "生日关怀",
        },
        {
          value: "会员帐单",
          label: "会员帐单",
        },
        {
          value: "等级升级前提醒",
          label: "等级升级前提醒",
        },
        {
          value: "等级升级后提醒",
          label: "等级升级后提醒",
        },
        {
          value: "中差评管理",
          label: "中差评管理",
        },
        {
          value: "手动评价",
          label: "手动评价",
        },
        {
          value: "手动审核退款",
          label: "手动审核退款",
        },
        {
          value: "评价预警",
          label: "评价预警",
        },
        {
          value: "退款预警",
          label: "退款预警",
        },
      ],
      typeValue: "",
      typeValue2: "",
      postForm: {
        sendStartTime: this.getDateStr(-30),
        sendEndTime: this.getDateStr(0),
        sendStartTime2: "",
        sendEndTime2: "",
      },
      topSelect: 2,
      inputData: [
        // 表单项
        {
          name: "活动主题:",
          val: "username",
          placeholder: "请输入买家姓名",
        },
        {
          name: "短信内容:",
          val: "username",
          placeholder: "请输入买家姓名",
        },
        {
          name: "手机号码:",
          val: "mobile",
          placeholder: "请输入手机号",
        },
        {
          name: "短信类型:",
          val: "status",
          selectArr: [
            { label: "状态1", id: 1 },
            { label: "状态2", id: 2 },
            { label: "状态3", id: 3 },
          ],
        },
        {
          name: "活动类型:",
          val: "status",
          selectArr: [
            { label: "全部", id: "" },
            { label: "状态2", id: 2 },
            { label: "状态3", id: 3 },
          ],
        },
        {
          val: "status",
          selectArr: [
            { label: "全部", id: "" },
            { label: "状态2", id: 2 },
            { label: "状态3", id: 3 },
          ],
        },
        {
          name: "发送状态:",
          val: "status",
          selectArr: [
            { label: "全部", id: "" },
            { label: "状态2", id: 2 },
            { label: "状态3", id: 3 },
          ],
        },
        {
          name: "发送时间:",
          myDate: true,
          val: ["orderStartTime", "orderEndTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      inputData1: [
        // 表单项
        {
          name: "手机号码:",
          val: "mobile",
          placeholder: "请输入手机号码",
        },
        {
          name: "短信内容:",
          val: "sendContent",
          placeholder: "请输入短信内容",
        },
        {
          name: "买家回复:",
          val: "replyContent",
          placeholder: "请输入买家回复",
        },
        {
          name: "发送时间:",
          myDate: true,
          val: ["startSendTime", "endSendTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "短信类型:",
          val: "comefrom",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: null },
            { label: "SHOP_WEB", id: "SHOP_WEB" },
            { label: "付款提醒", id: "付款提醒" },
            { label: "发货提醒", id: "发货提醒" },
            { label: "迟发提醒", id: "迟发提醒" },
            { label: "完成提醒", id: "完成提醒" },
            { label: "取消提醒", id: "取消提醒" },
            { label: "退货提醒", id: "退货提醒" },
            { label: "催付提醒", id: "催付提醒" },
            { label: "货到付款提醒", id: "货到付款提醒" },
            { label: "二次催付提醒", id: "二次催付提醒" },
            { label: "首购有礼", id: "首购有礼" },
            { label: "复购有礼", id: "复购有礼" },
            { label: "休眠有礼", id: "休眠有礼" },
            { label: "满月礼", id: "满月礼" },
            { label: "百日礼", id: "百日礼" },
            { label: "周年庆", id: "周年庆" },
            { label: "会员账单", id: "会员账单" },
            { label: "等级升级前提醒", id: "等级升级前提醒" },
            { label: "等级升级后提醒", id: "等级升级后提醒" },
            { label: "预售尾款催付提醒", id: "预售尾款催付提醒" },
            { label: "商品复购", id: "商品复购" },
          ],
        },
        {
          name: "状态:",
          val: "state",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: null },
            { label: "已读", id: 0 },
            { label: "未读", id: 1 },
          ],
        },
        {
          name: "回复时间:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      //短信记录查询数据
      recordData: {
        size: 10,
        current: 1,
        activityTitle: "", //活动主题
        dataFrom: 11, //活动类型数据来源
        content: "", //短信内容
        officialFlag: true, //活动类型
        sendType: "", //发送类型
        sendStatus: "", //发送状态
        submitTimeStart: "", //提交时间开始
        submitTimeEnd: "", //提交结束时间
        sendTimeStart: "", //发送时间开始
        sendTimeEnd: "", //发送时间结束
        orderStartTimeStart: this.getDateStr(-30) + " 00:00:00",
        orderStartTimeEnd: this.getDateStr(0) + " 23:59:59",
      },
      totalNum: 0,
      totalNumTwo: 0,
      recordTotal: 0,
      sortNum: {
        size: 10,
        current: 1,
        batchId: "",
        officialFlag: true,
        status: "",
        pin: "",
        mobile: "",
      },

      formList: {
        current: 1,
        size: 10,
      },
      currentRow: [],
      multipleSelection: [],
      mobileList: [],
      theID: "",
      remark: "",
      exportItem: {},

      //
      visible: false,
      phone: "",
      phoneStr: "",
      code: "",
      timer: null, //验证码定时
      successMsg: "",
      countdown: 60, // 倒计时s
      codeMsg: "获取验证码", // 按钮上的文字
      saveDisable: false,
      codeDisabled: false,

      fileData: {},
    };
  },
  components: {
    inputForm,
    formOne,
    sendSms,
    smsInfo,
    smsInfoCard,
    generate,
  },
  computed: {
    ...mapState({
      changeColor: "globalBG",
    }),
  },
  created() {
    // 埋点
    this.buriedPoint(1, "短信记录", "后台管理", "短信管理");
  },
  mounted() {
    // this.countTime[0] = this.getDateStr(-30)  + " 00:00:00",
    // this.countTime[1] = this.getDateStr(0)  + " 23:59:59",
    // this.getQueryBills();
    // this.infoSearch();
    if(this.$route.query.activityType){
      
      this.$refs.formOne0.formData.activityType = Number(this.$route.query.activityType)
      this.$refs.formOne0.submitForm();
      // this.$refs.formOne0.setData('formData.activityType',Number(this.$route.query.activityType))
    }else{
      this.handlePrecisionRec(this.recordData);
    }
    
    getSellerInfo().then((res) => {
      this.shopInfo.isSimulation = res.data.isSimulation;
      //this.phoneNum=res.data.mobile;
    });
  },
  methods: {
    showMediaInfo(row) {
      this.smsInfoShow = true;
      this.smsInfoId = row.mediaMulitiFileId;
      this.smsInfoTitle = row.mediaTitle;
      this.smsInfoText = row.content;
    },
    showCardInfo(row){
      this.smsInfoCardShow = true
      this.smsInfoCardId = row.mediaTemplateId
    },
    async getphone() {
      if (this.shopInfo.isSimulation) {
        this.$message.error("非法登录不支持操作");
        return;
      }
      this.control = true;
    },
    async getphone1(val) {
      this.control = true;
      // 活动类型为精准营销
      let params = this.fileData;
      params.source = 3;
      params.exportRemark = val
      let data = "";
      if (this.recordData.dataFrom == 11) {
        let postData = this.$refs.formOne0.formData
        data = await setMessageGf({...params,...postData});
        this.control = true;
      }
      // 活动类型为智能营销
      else if (this.recordData.dataFrom == 3) {
        let postData = this.$refs.formOne1.formData
        data = await setMessageJz({...postData,...params});
        this.control = true;
      } else {
        let dataFrom = [];
        dataFrom.push(params.dataFrom);
        params.dataFrom = dataFrom;
        let postData = this.$refs.formOne2.formData
        data = await setMessageft({...postData,...params});
        this.control = true;
      }
    },
    /** 获取验证码 */
    getCode() {
      if (!this.timer) {
        let parasm = { bindingPhone: this.phone, source: 3 };
        getSellerCheckCode(parasm).then((res) => {
          if (res.code == 1) {
            this.codeDisabled = true;
            this.timer = setInterval(() => {
              if (this.countdown > 0 && this.countdown <= 60) {
                this.countdown--;
                if (this.countdown !== 0) {
                  this.codeMsg = "重新发送(" + this.countdown + ")";
                } else {
                  clearInterval(this.timer);
                  this.codeMsg = "获取验证码";
                  this.countdown = 60;
                  this.timer = null;
                  this.codeDisabled = false;
                }
              }
            }, 1000);
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },

    async downloadFileMessage() {
      if (!this.code) {
        this.$message.warning("请输入验证码");
        return;
      }

      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      // 活动类型为精准营销
      let params = this.fileData;
      params.code = this.code;
      params.source = 3;
      let data = "";
      if (this.recordData.dataFrom == 11) {
        data = await setMessageGf(params);
      }
      // 活动类型为智能营销
      else if (this.recordData.dataFrom == 3) {
        data = await setMessageJz(params);
      } else {
        let dataFrom = [];
        dataFrom.push(params.dataFrom);
        params.dataFrom = dataFrom;
        data = await setMessageft(params);
      }

      loading.close();

      if (data.code == 1) {
        var blob = new Blob([data.blob]);
        var link = document.createElement("a"); //a标签下载
        link.href = window.URL.createObjectURL(blob);
        link.download = "短信记录.xls";
        link.click();
        window.URL.revokeObjectURL(link.href);

        this.visible = false;
      } else {
        this.$message.warning(data.message);
      }
    },

    handleCheckAllChange(val) {
      this.checkedCities = val ? this.cities : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cities.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.cities.length;
    },
    //导出
    exportRec() {
      // if (this.currentRow.length > 0) {
      this.dialogFormExport = true;
      // this.theID = this.mobileList.join(",");
      // } else {
      //   this.$message.warning("请选择一个选项");
      // }
    },
    exportData() {
      let theItem = {};

      if (this.checkedCities.includes("手机号码")) {
        theItem.mobile = "手机号码";
      }
      if (this.checkedCities.includes("发送内容")) {
        theItem.sendContent = "发送内容";
      }
      if (this.checkedCities.includes("发送时间")) {
        theItem.sendTime = "发送时间";
      }
      if (this.checkedCities.includes("回复内容")) {
        theItem.content = "回复内容";
      }
      if (this.checkedCities.includes("回复时间")) {
        theItem.crtime = "回复时间";
      }
      let formData = JSON.stringify(theItem);
      // let aa = formData.replace(/\[|]/g, "");
      // console.log(formData, "theVal");
      let param = { size: 10, current: 1, exportJsonStr: formData };
      var paramStr = "";
      for (var key in param) {
        var temp = "&" + key + "=" + param[key];
        paramStr += temp;
      }
      paramStr = paramStr.substr(1);

      let elem = document.createElement("a");
      elem.style.display = "none";
      let url = "/jd-yusms/smsReceive/export?" + encodeURI(paramStr);
      elem.href = url;
      document.body.appendChild(elem);
      elem.click();
      document.body.removeChild(elem);

      exportRecordMes(param).then((res) => {
        this.dialogFormExport = false;
        // console.log(res);
      });
    },
    handleViewRecord() {
      // console.log(this.$parent);
    },
    //发送短信模态框
    drawerClose() {
      this.drawer = false;
      this.multipleSelection = [];
    },
    callBackDef(row) {
      this.multipleSelection = this.mobileList;
      if (this.multipleSelection.length > 0 && !row) {
        this.sendType = 0;
        this.checkCount = this.multipleSelection.length;
        this.drawer = true;
        // this.theID = this.multipleSelection.join(",");
      } else if (this.multipleSelection.length == 0 && !row) {
        this.$message.warning("请选择一个选项");
      } else if (row.mobile) {
        this.sendType = 0;
        this.checkCount = 1;
        this.drawer = true;
        this.multipleSelection = [];
        this.multipleSelection.push(row.mobile);
      }
      console.log(this.multipleSelection, 2345);
    },
    //页头
    changeTo(val) {
      this.topSelect = val;
      if (val == 1) {
        this.sendRecord();
      } else if (val == 2) {
        this.smsType = 0;
        this.$refs.formOne0.submitForm();
      } else if (val == 3) {
        this.smsType = 2;
        this.$refs.formOne2.submitForm();
      }else {
        this.smsType = 1;
        this.$refs.formOne1.submitForm();
      }
      console.log("this.smsType------>", this.smsType);
    },
    handleSelectionChange(val) {
      this.currentRow = [];
      this.mobileList = [];
      val.forEach((item) => {
        this.currentRow.push(item.rid);
        this.mobileList.push(item.mobile);
        // this.sendContentList.push(item.sendContent);
      });
      this.exportItem = JSON.parse(JSON.stringify(val));
    },
    //批量删除
    toggleSelection(row) {
      if (this.currentRow.length > 0 && !row) {
        this.dialogFormVis = true;
        this.theID = this.currentRow.join(",");
      } else if (this.currentRow.length == 0 && !row) {
        this.$message.warning("请选择一个选项");
      } else if (row.rid) {
        this.dialogFormVis = true;
        this.theID = row.rid;
      }
    },
    deleteDefine() {
      deleteRecordMes({ ids: this.theID })
        .then((res) => {
          if (res && res.code == 1) {
            this.sendRecord();
            this.dialogFormVis = false;
            this.$message.success("删除成功");
          }
        })
        .catch(() => {});
    },
    //加入黑名单
    blacklistDef() {
      if (this.currentRow.length > 0) {
        this.dialogFormBlack = true;
        this.theID = this.mobileList;
        // this.theID = this.mobileList.join(",");
      } else {
        this.$message.warning("请选择一个选项");
      }
    },
    blacklistDefine() {
      insertBlack({ mobiles: this.theID, remark: this.remark, type: 0 })
        .then((res) => {
          if (res && res.code == 1) {
            this.sendRecord();
            this.dialogFormBlack = false;
            this.$message.success(
              "添加成功" +
                res.data.sucessNum +
                "个; 失败" +
                res.data.fialNum +
                "个"
            );
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((res) => {});
    },
    //一键标记已读
    readDefine() {
      if (this.currentRow.length > 0) {
        // this.theID = this.currentRow.join(",");
        var param = "?ids=" + this.currentRow.join(",") + "&state=0";
        // readRecordMes({ ids:this.theID, state: 0 })
        readRecordMes(param)
          .then((res) => {
            if (res && res.code == 1) {
              this.$message.success(res.message);
              this.sendRecord();
            } else {
              this.$message.error(res.message);
            }
          })
          .catch((res) => {});
      } else {
        this.$message.warning("请选择一个选项");
      }
    },
    //短信回复获取列表
    sendRecord() {
      this.loading = true;
      sendRecordMes(this.formList)
        .then((res) => {
          this.tableDataReply = res.data.records;
          this.totalNumTwo = res.data.total;
          this.loading = false;
        })
        .catch(() => {});
    },
    //查询短信回复
    searchContent(val) {
      this.formList.size = 10;
      this.formList.current = 1;
      this.formList.mobile = val.mobile;
      this.formList.sendContent = val.sendContent;
      this.formList.replyContent = val.replyContent;
      this.formList.startSendTime = val.startSendTime;
      this.formList.endSendTime = val.endSendTime;
      this.formList.comefrom = val.comefrom;
      this.formList.state = val.state;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.sendRecord();
    },

    //进页面查询
    infoSearch() {
      this.loading = true;
      let obj = {
        ...JSON.parse(JSON.stringify(this.recordData)),
        smsType: this.smsType,
      };
      this.fileData = obj; //拦截导出数据
      console.log("jym");
      recordList(obj)
        .then((res) => {
          this.countTable = res.data.records;
          this.totalNum = res.data.total;
          this.loading = false;

          if (this.smsType == 1 || this.smsType == 2) {
            this.activityTypeStr = this.activityTypeName(
              this.recordData.dataFrom
            );
          }
        })
        .catch(() => {});
    },
    //短信记录弹窗查询
    recordPopupQuery() {
      this.sortNum.current = 1;

      this.sortNum.mobile = this.formInline.number;
      // this.sortNum.status= this.formInline.sendStatus;
      this.sortNum.status = this.formInline.sendStatus;
      this.sortNum.pin = this.formInline.user;
      this.sendRec();
    },
    recordPopupReset() {
      this.formInline.number = "";
      this.formInline.sendStatus = "";
      this.formInline.user = "";
    },
    //分页
    handleCurrentChange(val) {
      this.recordData.current = val;
      this.recordData.orderStartTimeStart =
        sessionStorage.getItem("submitTimeStart_s");
      this.recordData.orderStartTimeEnd =
        sessionStorage.getItem("submitTimeEnd_s");
      this.recordData.sendStartTimeStart =
        sessionStorage.getItem("sendTimeStart_s");
      this.recordData.sendStartTimeEnd =
        sessionStorage.getItem("sendTimeEnd_s");
      if (this.recordData.dataFrom != 11 && this.recordData.dataFrom != 3) {
        this.infoSearch();
      } else if (this.recordData.dataFrom == 3) {
        this.handleintelligentRec(this.recordData);
      } else {
        this.handlePrecisionRec(this.recordData);
      }
    },
    handleSizeChange(val) {
      this.recordData.orderStartTimeStart =
        sessionStorage.getItem("submitTimeStart_s");
      this.recordData.orderStartTimeEnd =
        sessionStorage.getItem("submitTimeEnd_s");
      this.recordData.sendStartTimeStart =
        sessionStorage.getItem("sendTimeStart_s");
      this.recordData.sendStartTimeEnd =
        sessionStorage.getItem("sendTimeEnd_s");
      this.recordData.size = val;
      if (this.recordData.dataFrom != 11 && this.recordData.dataFrom != 3) {
        this.infoSearch();
      } else if (this.recordData.dataFrom == 3) {
        this.handleintelligentRec(this.recordData);
      } else {
        this.handlePrecisionRec(this.recordData);
      }
    },
    //弹窗分页
    handleSizeChangeOne(val) {
      this.sortNum.size = val;
      this.sendRec();
    },
    handleCurrentChangeOne(val) {
      this.sortNum.current = val;
      this.sendRec();
    },
    handleSizeChangeTwo(val) {
      this.formList.size = val;
      this.sendRecord();
    },
    handleCurrentChangeTwo(val) {
      this.formList.current = val;
      this.sendRecord();
    },
    setParams(val) {
      let params = {};
      params.current = this.recordData.current;
      params.size = this.recordData.size;
      params.activityTitle = val.theme;
      params.content = val.fullName;
      params.sendStatus = val.orderstatus;
      params.submitTimeStart = val.orderStartTimeStart;
      params.submitTimeEnd = val.orderStartTimeEnd;
      params.sendTimeStart = val.sendStartTimeStart;
      params.sendTimeEnd = val.sendStartTimeEnd;
      params.smsType = this.smsType;
      return params;
    },

    //查询条件数据查询
    searchFormOne(val) {
      // var typeDataFrom = [];
      // typeDataFrom.push(val.activityType);
      sessionStorage.setItem("submitTimeStart_s", val.orderStartTimeStart)
      sessionStorage.setItem("submitTimeEnd_s", val.orderStartTimeEnd)
      sessionStorage.setItem("sendTimeEnd_s", val.sendStartTimeEnd)
      sessionStorage.setItem("sendTimeStart_s", val.sendStartTimeStart)
      sessionStorage.setItem("sendStatus", val.orderstatus)
      this.recordData.current = 1;
      this.recordData.activityTitle = val.theme;
      this.recordData.content = val.fullName;
      this.recordData.officialFlag = val.orderRemark == 0 ? true : false;
      this.recordData.dataFrom = val.activityType;
      this.recordData.sendStatus = val.orderstatus;
      this.recordData.submitTimeStart = val.orderStartTimeStart;
      this.recordData.submitTimeEnd = val.orderStartTimeEnd;
      this.recordData.sendTimeStart = val.sendStartTimeStart;
      this.recordData.sendTimeEnd = val.sendStartTimeEnd;
      // 活动类型为精准营销
      if (this.recordData.dataFrom == 11) {
        this.handlePrecisionRec(val);
      }
      // 活动类型为智能营销
      else if (this.recordData.dataFrom == 3) {
        this.handleintelligentRec(val);
      } else {
        this.infoSearch();
      }
    },

    // 过滤出活动类型
    activityTypeName(type) {
      const obj = {
        11: "精准营销",
        3: "智能营销",
        1: "会员发送",
        2: "订单发送",
        15: "预售订单发售",
      };
      return obj[type];
    },

    // 短信记录接口查询
    sendRec() {
      sendDetailRecord(this.sortNum)
        .then((res) => {
          this.gridData = res.data.records;
          this.recordTotal = res.data.total;
        })
        .catch(() => {});
    },
    // 智能营销短信记录查询
    handleintelligentRec(val) {
      let params = this.setParams(val);
      this.intelligentRec(params);
    },
    // 精准营销短信记录查询
    handlePrecisionRec(val) {
      let params = this.setParams(val);
      this.precisionRec(params);
    },
    precisionRec(params) {
      this.loading = true;
      console.log("jz",params);
      this.fileData = params; //导出数据
      params.sendStatus = sessionStorage.getItem("sendStatus")
      // if(!params.sendStatus){
      //   params.sendStatus = ''
      // }else {
      //   params.sendStatus = sessionStorage.getItem("sendStatus")
      // }
      params.sendStatus = sessionStorage.getItem("sendStatus")
      getRecordListOfficial(params).then((res) => {
        this.countTable = res.data.records;
        this.totalNum = res.data.total;
        this.loading = false;
        if (this.smsType == 1 || this.smsType == 2) {
          this.activityTypeStr = this.activityTypeName(
            this.recordData.dataFrom
          );
        }
      });
    },
    // 智能营销短信记录查询
    intelligentRec(params) {
      this.loading = true;
      console.log("zn");
      this.fileData = params; //导出数据
      console.log("11111", params);
      let param = {
        ...params,
        subStartTime:params.submitTimeStart,
        subEndTime:params.submitTimeEnd,
        sendStartTime:params.sendTimeStart,
        sendEndTime:params.sendTimeEnd
      }
      // if(!param.sendStatus){
      //   param.sendStatus = ''
      // }else {
      //   params.sendStatus = sessionStorage.getItem("sendStatus")
      // }
      params.sendStatus = sessionStorage.getItem("sendStatus")
      getSmsRecordPage(param).then((res) => {
        this.countTable = res.data.records;
        this.totalNum = res.data.total;
        this.loading = false;
        if (this.smsType == 1 || this.smsType == 2) {
          this.activityTypeStr = this.activityTypeName(
            this.recordData.dataFrom
          );
        }
      });
    },

    sortRecord(val) {
      this.dialogFormVisible = true;
      this.sortNum.batchId = val.id;
      console.log(val.officialFlag);
      if (val.officialFlag == true) {
        this.sortNum.officialFlag = true;
      } else {
        this.sortNum.officialFlag = false;
      }
      this.sortNum.status = "";
      this.sendRec();
    },
    // 取消发送
    handleCancelSend(row, index) {
      this.$confirm("确定要取消吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass: "iconfont iconicon-jinggao1",
      }).then(() => {
        var param = {
          batchId: row.id,
          officialFlag: row.officialFlag,
        };
        if (this.recordData.dataFrom == 11) {
          var param = {
            sendTime: row.sendTime,
            // activityRecordId: row.activityRecordId,
            id:row.id,
          };
          cancelSendSms(param).then((res) => {
            if (res.code == "1") {
              this.$message.success("取消发送成功");
              this.handlePrecisionRec(this.recordData);
            } else {
              this.$message.error(res.message);
            }
          });
          return;
        }
        // 智能营销取消发送
        else if (this.recordData.dataFrom == 3) {
          var param = {
            sellerNick: row.sellerNick,
            // activityRecordId: row.activityRecordId,
            id: row.id
          };
          console.log(param);
          cancelSendSms2(param).then((res) => {
            if (res.code == "1") {
              this.$message.success("取消发送成功");
              this.handleintelligentRec(this.recordData);
            } else {
              this.$message.error(res.message);
            }
          });
          return;
        }
        sendCancel(param).then((res) => {
          if (res.code == "1") {
            this.$message.success("取消发送成功");
            // this.sendRecord();
            this.infoSearch();
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.rich_title {
  color: #7f85e9;
  font-size: 14px;
  cursor: pointer;
}

/deep/.system-dialog {
  .el-dialog__body {
    padding: 16px 30px 30px 30px;
  }
  .form-box {
    padding-top: 16px;
    .form-item {
      font-size: 14px;
      color: #333;
      margin-bottom: 12px;
      .item-label {
        display: inline-block;
        width: 76px;
        text-align: right;
      }
      .item-value {
        display: inline-block;
      }
    }
  }
  .save-btn {
    text-align: center;
  }

  .backBtn {
    margin-left: 20px;
    width: 98px;
    height: 32px;
    color: #666666;
    border-radius: 3px;
    border: 1px solid #dddddd;
    background-color: #fff;
    &:hover {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
    &:active {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }
  .keepBtn {
    width: 98px;
    height: 32px;
    border-radius: 3px;
    background-color: #fe4d45;
    color: #fff;
    &:hover {
      opacity: 0.9;
    }
  }
}
/deep/.el-dialog__header span {
  width: 64px !important;
  height: 22px !important;
  font-size: 16px !important;
  font-weight: bold !important;
  line-height: 28px !important;
  color: rgba(51, 51, 51, 1) !important;
  opacity: 1 !important;
}
/deep/.el-dialog {
  border-radius: 6px !important;
}
/deep/ .el-dialog .el-dialog__header {
  background-color: #fff;
  border-bottom: 1px solid rgba(243, 243, 243, 1);
  opacity: 1;
  height: 54px;
  line-height: 54px;
}
/deep/.table-message {
  color: #7f85e9;
}
/deep/.messContent {
  // float: left;
  margin-left: -30px;
  cursor: pointer;
  color: #7f85e9;
  &:hover {
    color: #fe4d45;
  }
}
.operation-wrap {
  .el-button {
    width: auto !important;
    padding: 0 !important;
    color: #7f85e9;
  }
}
.lineLengthHige {
  top: 71px;
  width: 100%;
  height: 1px;
  border-radius: 1px;
  position: relative;
  background: rgba(243, 243, 243, 1);
  opacity: 1;
}
.b1 {
  width: 98px;
  height: 32px;
  font-size: 14px;
  border-radius: 3px;
  color: #fe4d45;
  border: 1px solid #fe4d45;
  background-color: #fff;
  &:hover {
    color: #fff;
    border: 1px solid #fff;
    background-color: #fe4d45;
  }
}
.b2 {
  width: 98px;
  height: 32px;
  font-size: 14px;
  border-radius: 3px;
  color: #666666;
  border-radius: 3px;
  border: 1px solid #dddddd;
  background-color: #fff;
  &:hover {
    color: #fe4d45;
    border: 1px solid #fe4d45;
    background-color: #fff4f4;
  }
}
.titileDefinition {
  height: 57px;
  line-height: 57px;
  padding: 0 20px;
  font-size: 20px;
  color: #333333;
  font-weight: bold;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  opacity: 1;
}
.dot {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  opacity: 1;
  margin-right: 7px;
}
.dot-0 {
  background: rgba(73, 197, 104, 1);
}
.dot-1 {
  background: #ffb95e;
}
.dot-2 {
  background: #cccccc;
}
.dot-3 {
  background: #fe4d45;
}
.dot-4 {
  background: #7f85e9;
}
.section-right-content-box {
  min-width: 1066px;
  margin-top: 10px;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  opacity: 1;
  margin: 10px 20px 20px 20px;
  .navTab {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding: 0 20px;
    position: relative;
    height: 50px;
    font-size: 14px;
    color: #999;
    border-bottom: 1px solid #f6f6f6;
    span {
      height: 50px;
      line-height: 50px;
      position: relative;
      padding: 0 11px;
      cursor: pointer;
      transition: all 0.2s;
    }
    .active {
      color: #fe4d45;
      &::before {
        content: "";
        position: absolute;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        width: 80%;
        height: 2px;
        background-color: #fe4d45;
        transition: all 0.2s;
        animation: opation 0.2s;
      }
      @keyframes opation {
        0% {
          opacity: 0;
        }
        100% {
          opacity: 100%;
        }
      }
    }
  }
  .headBtns {
    display: flex;
    align-items: center;
    margin: 30px 30px 0 30px;
    button {
      min-width: 122px;
      height: 32px;
      line-height: 28px;
      background-color: white;
      outline: none;
      cursor: pointer;
      text-align: center;
      transition: all 0.2s;
      border-radius: 3px;
      border: none;
    }
    .b1 {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 138px;
      color: #fff;
      margin-bottom: 20px;
      background-color: #fe4d45;
      &:hover {
        opacity: 0.9;
      }
      .icon {
        margin-right: 2px;
        width: 12px;
        height: 12px;
      }
    }
    .b2 {
      margin: 0 12px 20px 12px;
      border: 1px solid #fe4d45;
      color: #fe4d45;
      margin-bottom: 20px;
      &:hover {
        background-color: #fe4d45;
        color: #fff;
      }
    }
    .b3 {
      border: 1px solid #dddddd;
      color: #666666;
      margin: 0 10px 20px 0;
      &:hover {
        border: 1px solid #fe4d45;
        background-color: #fe4d45;
        color: #fff;
      }
    }
  }
  .daoChu {
    float: right;
    margin: -50px 60px 0 0;
  }
  .tabCallback {
    margin: 0 0 0 30px;
    width: 95%;
  }
  .searchClass {
    width: 350px;
    height: 32px;
    display: inline-block;
    margin-right: 77px;
    margin-bottom: 16px;
    .item {
      display: inline-block !important;
      width: 280px;
    }
  }
  .input-form-box {
    padding: 24px 28px;
    border-radius: 6px;
    .el-form-item {
      margin-right: 40px;
    }
  }
  .search-box {
    margin-bottom: 20px;
    text-align: left;
    font-size: 14px;
    .timePicker {
      vertical-align: middle;
      margin-right: 10px;
    }
    .button {
      vertical-align: middle;
    }
  }
  .hugStyleClass {
    overflow: hidden;
    color: #333;
    font-size: 14px;
    margin-bottom: 20px;
    cursor: pointer;
    .underlinedFor {
      height: 2px;
      width: 40px;
      margin-left: 8px;
      text-align: center;
      margin-top: 14px;
      opacity: 1;
      cursor: pointer;
    }
  }
  .headForm {
    padding: 22px 22px 5px 22px;
    margin-left: -38px;
  }
}
.show-detail-wrapper {
  .search-head {
    text-align: left;
    margin-bottom: 20px;
    .time-picker {
      vertical-align: middle;
      margin-right: 30px;
    }
    .content-input {
      width: 200px;
      display: inline-block;
      vertical-align: middle;
      margin-right: 15px;
    }
    .button {
      vertical-align: middle;
    }
  }
}
.buttonBox {
  .b1 {
    width: 98px;
    height: 32px;
    color: #666666;
    // position: absolute;
    border-radius: 3px;
    margin-top: 20px;
    border: 1px solid #dddddd;
    background-color: #fff;
    &:hover {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
    &:active {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }
  .b2 {
    width: 98px;
    // position: absolute;
    // margin-right: 80px;
    height: 32px;
    margin: 20px 80px 10px 10px;
    border: 1px solid #fe4d45;
    color: #ffffff;
    border-radius: 3px;
    background-color: #fe4d45;
    &:hover {
      color: #fff;
      opacity: 0.9;
      background-color: #fe4d45;
    }
    &:active {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }
}
.question_icon {
  width: 14px;
  height: 14px;
  color: #7f85e9 !important;
  display: inline-block;
  line-height: 12px !important;
  text-align: center;
  border-radius: 14px;
  border: 1px solid #fe4d45;
  font-size: 12px !important;
  font-weight: normal !important;
  margin-left: 8px;
  &:hover {
    color: #fe4d45 !important;
    border: 1px solid #fe4d45;
  }
}
</style>
